import React from "react";
import { ErrorMessage, Field, FieldProps } from "formik";

type InputAttributes = React.InputHTMLAttributes<HTMLInputElement> &
  React.TextareaHTMLAttributes<HTMLTextAreaElement>;

interface FormFieldProps extends InputAttributes {
  label?: string;
  name: string;
  type?: string;
  variant?: "default" | "inner";
  validate?: (value: any) => string | Promise<void> | undefined;
  showError?: boolean;
}

const TextField = ({
  label,
  name,
  type,
  validate,
  value,
  variant = "default", 
  onChange,
  onBlur,
  className,
  showError = true,
  ...props
}: FormFieldProps) => {
  const inputProps = {
    id: name,
    "aria-describedby": `${name}Error`,
    ...props,
  };

  const isTextArea = type === "textarea";

  return (
    <Field type={type} name={name} validate={validate}>
      {({ field }: FieldProps) => (
        <div className="mb-4 w-full">
          {label && (
            <label
              className="block text-sm text-left font-base text-gray-100 mb-2"
              htmlFor={inputProps.id}
            >
              {label}
            </label>
          )}
          {isTextArea && (
            <textarea {...field} {...inputProps} onChange={onChange} placeholder="Type here..." className={`bg-transparent text-left text-black placeholder-white border-2 rounded-xl w-full  py-3 border-gray-70 ${className}`}></textarea>
          )}
          {!isTextArea && (
            <input {...field} {...inputProps} onChange={onChange} type={type} 
            className={`bg-gray-100 text-left text-black placeholder-gray-600 border-2 rounded-xl w-full px-4 py-3 border-kyzzen-secondary ${className}`}
            
            />
          )}
          {showError && (
            <span className="text-red-500 mt-2 block text-sm text-center">
              <ErrorMessage
                name={name}
                data-test-id={`${name}-error-message`}
              />
            </span>
          )}
        </div>
      )}
    </Field>
  );
};

export default TextField;

export const TextFieldTransparent = ({
  label,
  name,
  type,
  validate,
  value,
  variant = "default", 
  onChange,
  onBlur,
  className,
  showError = true,
  ...props
}: FormFieldProps) => {
  const inputProps = {
    id: name,
    "aria-describedby": `${name}Error`,
    ...props,
  };

  const isTextArea = type === "textarea";

  return (
    <Field type={type} name={name} validate={validate}>
      {({ field }: FieldProps) => (
        <div className="mb-4 w-full">
          {label && (
            <label
              className="block text-sm text-left font-base text-gray-100 mb-2"
              htmlFor={inputProps.id}
            >
              {label}
            </label>
          )}
          {isTextArea && (
            <textarea {...field} {...inputProps} onChange={onChange} className="input"></textarea>
          )}
          {!isTextArea && (
            <input {...field} {...inputProps} onChange={onChange} type={type} 
            className={`bg-transparent text-left text-gray-40 placeholder-gray-600 border-2 rounded-xl w-full px-4 py-3 border-kyzzen-secondary ${className}`}
            
            />
          )}
          {showError && (
            <span className="text-red-500 mt-2 block text-sm text-center">
              <ErrorMessage
                name={name}
                data-test-id={`${name}-error-message`}
              />
            </span>
          )}
        </div>
      )}
    </Field>
  );
};

